import React, { useMemo } from 'react';
import cn from 'classnames';
import logo from 'src/assets/images/logo-no-title.png';
import { header } from 'src/assets/locales/en/common.json';
import styles from './NavLogo.module.scss';
import { useUserValues } from 'src/hooks';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';
import { useSelector } from 'react-redux';
import { userRoleSelector } from 'src/redux/selectors';

interface NavLogoProps {
  isPrivatePage: boolean;
  onToggleAside?: () => void;
}

const NavLogo = ({ isPrivatePage, onToggleAside }: NavLogoProps): JSX.Element => {
  const { profileName, companyName } = useUserValues();
  const userRole = useSelector(userRoleSelector);

  const profileDisplayName = useMemo(() => {
    const companyText = companyName ? ` | ${companyName}` : '';
    const nameText = `${profileName} ${companyText}`;

    const text = {
      [ACCOUNT_ROLES.COMPANY]: companyName ?? '',
      [ACCOUNT_ROLES.USER]: profileName ? nameText : ''
    };

    return text[userRole] ?? '';
  }, [companyName, profileName, userRole]);

  return (
    <div className={cn(styles.contentWrapper, { [styles.privatePageBehavior]: isPrivatePage })} onClick={onToggleAside}>
      <div className={styles.logoWrapper}>
        <img src={logo} alt={header.logoAlt} className={cn(styles.logo, 'img-fluid')} />
      </div>

      <h1 className={styles.logoTitle}>{header.logoTitle}</h1>
      {isPrivatePage && profileDisplayName ? (
        <span className={cn(styles.profileName, styles.logoTitle)}>{`for ${profileDisplayName}`}</span>
      ) : null}
    </div>
  );
};

export default NavLogo;
